import blitz from "blitzllama-js";
import { useGetCreatorConfigQuery } from "../../redux/efficientReduxAPI";

export const useBlitzllama = () => {
  const { data: creatorConfigData } = useGetCreatorConfigQuery();
  const authorizations = creatorConfigData?.authorizations || {};
  const is_boi_flipkart = !!creatorConfigData?.is_boi_flipkart;

  const blitzllamaEnabled =
    authorizations?.SOCIAL_LOGIN?.achieved && !localStorage.adminToken;

  function initializeBlitzllama() {
    const api_key = "key_BzfHHOqbKfCZufc";
    try {
      blitz.init(api_key);
    } catch (error) {
      //
    }
  }
  function setBlitzllamaUserId(user_id) {
    try {
      if (blitzllamaEnabled) {
        blitz.createUser(user_id);
      }
    } catch (error) {
      //
    }
  }
  function setCommmonUserProperties(has_sourcing_access, username, name) {
    try {
      if (blitzllamaEnabled) {
        const {
          APP_DOWNLOAD,
          PROFILE_COMPLETED,
          SOCIAL_LOGIN,
          EARNINGS_CROSS_2K,
          ENGAGE_CONNECTED,
          FIRST_COLLECTION,
          FIRST_LINK_CREATED,
          FIRST_LINK_SKIPPED,
          FIRST_POST,
          FIRST_SALE,
          ONBOARDING_BRANDS_SELECTION_COMPLETE,
        } = authorizations;

        if (APP_DOWNLOAD) {
          const app_download_milestone = APP_DOWNLOAD?.achieved;
          const creator_profile_milestone = PROFILE_COMPLETED?.achieved;
          const creator_social_login_complete = SOCIAL_LOGIN?.achieved;
          const earnings_cross_2k_milestone = EARNINGS_CROSS_2K?.achieved;
          const engage_connected_milestone = ENGAGE_CONNECTED?.achieved;
          const first_collection_milestone = FIRST_COLLECTION?.achieved;
          const first_link_created_milestone = FIRST_LINK_CREATED?.achieved;
          const first_link_skipped_milestone = FIRST_LINK_SKIPPED?.achieved;
          const first_post_milestone = FIRST_POST?.achieved;
          const first_sale_milestone = FIRST_SALE?.achieved;
          const onboarding_brands_selection_complete_milestone =
            ONBOARDING_BRANDS_SELECTION_COMPLETE?.achieved;
          blitz.setUserProperties({
            app_download_milestone,
            creator_profile_milestone,
            creator_social_login_complete,
            earnings_cross_2k_milestone,
            engage_connected: engage_connected_milestone,
            first_collection_milestone,
            first_link_created: first_link_created_milestone,
            first_link_skipped: first_link_skipped_milestone,
            first_post_milestone,
            first_sale_milestone,
            onboarding_brands_selection_complete:
              onboarding_brands_selection_complete_milestone,
          });

          blitz.setUserProperties({
            has_sourcing_access,
            is_boi_flipkart,
            username,
            name,
          });
        }
      }
    } catch (error) {
      //
    }
  }

  function setUserProperties(properties) {
    try {
      if (blitzllamaEnabled) {
        blitz.setUserProperties(properties);
      }
    } catch (error) {
      //
    }
  }
  function triggerEvent(trigger, properties, skip = false) {
    try {
      if (blitzllamaEnabled || skip) {
        blitz.triggerEvent(trigger, properties);
      }
    } catch (error) {
      //
    }
  }
  function logout() {
    try {
      blitz.logout();
    } catch (error) {
      //
    }
  }

  return {
    initializeBlitzllama,
    setBlitzllamaUserId,
    setCommmonUserProperties,
    setUserProperties,
    triggerEvent,
    logout,
  };
};
